import { useDocumentLibraryStore } from '@roc/feature-document-library';

// Shared hook so the template download logic lives in one place.
export const useDownloadTrackRecordTemplate = () => {
  const { documentLibraryStore } = useDocumentLibraryStore();

  return () => {
    try {
      documentLibraryStore.downloadTrackRecordTemplate();
    } catch (error) {
      // template download is non-critical, but surface the error for monitoring
      console.error('Error downloading track record template:', error);
    }
  };
};
